import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext } from 'react';
import { Button, createForm, Flex, RadioGroup, Text } from '@applyboard/crystal-ui';
import { useCurrentUser } from '@applyboard/ui-utils';
import { useOnboardingFormControllerContext } from "../../../controller/OnboardingFormController";
import { storeBudgetValue, getStoredBudget, deleteStoredBudget } from "../../storage/Budget/localStorage";
import { LoadingOverlay } from "../../../../ab-common-legacy/LoadingOverlay";
import { useEditStudentPreferences, useStudentPreferences, useDeleteStudentPreferences } from "../../../../data/studentPreferences";
import { BUDGET_OPTIONS } from "./consts";
import { FormStateContext } from "../../../FormStateProvider";
import { Layout } from "../../Layout";
import { PreferencesContainer } from "../../Layout/PreferencesContainer";
var _createForm = createForm(),
  Field = _createForm.Field,
  Form = _createForm.Form;
export var BudgetPage = function BudgetPage() {
  var _useCurrentUser = useCurrentUser(),
    _useCurrentUser2 = _slicedToArray(_useCurrentUser, 1),
    user = _useCurrentUser2[0];
  var userId = user === null || user === void 0 ? void 0 : user.id;
  var _useOnboardingFormCon = useOnboardingFormControllerContext(),
    handlePassed = _useOnboardingFormCon.handlePassed,
    handleSkipped = _useOnboardingFormCon.handleSkipped,
    handleError = _useOnboardingFormCon.handleError;
  var _useContext = useContext(FormStateContext),
    onShowError = _useContext.onShowError;
  var _useStudentPreference = useStudentPreferences(userId, {
      enabled: Boolean(userId)
    }),
    studentPreferences = _useStudentPreference.studentPreferences,
    isLoadingStudentPreferences = _useStudentPreference.isLoadingStudentPreferences;
  var _useEditStudentPrefer = useEditStudentPreferences(userId, 'budget'),
    editStudentPreferences = _useEditStudentPrefer.editStudentPreferences;
  var _useDeleteStudentPref = useDeleteStudentPreferences(userId, 'budget'),
    deleteStudentPreferences = _useDeleteStudentPref.deleteStudentPreferences;
  if (isLoadingStudentPreferences) {
    return /*#__PURE__*/React.createElement(LoadingOverlay, {
      "aria-label": "Loading"
    });
  }
  var signedInSubmit = function signedInSubmit(budget) {
    if (budget) {
      var data = {
        values: Number(budget)
      };
      editStudentPreferences(data, {
        onSuccess: function onSuccess() {
          handlePassed();
        },
        onError: function onError() {
          onShowError();
          handleError();
        }
      });
    } else {
      deleteStudentPreferences(undefined, {
        onSuccess: function onSuccess() {
          handlePassed();
        },
        onError: function onError() {
          onShowError();
          handleError();
        }
      });
    }
  };
  var skipBudgetSubmit = function skipBudgetSubmit() {
    if (userId) {
      deleteStudentPreferences(undefined, {
        onSuccess: function onSuccess() {
          handleSkipped();
        },
        onError: function onError() {
          onShowError();
          handleError();
        }
      });
    } else {
      deleteStoredBudget();
      handleSkipped();
    }
  };
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: function onSubmit(data) {
      var budget = data.budget;
      if (userId) {
        signedInSubmit(budget);
      } else {
        storeBudgetValue([budget]);
        handlePassed();
      }
    },
    defaultValues: {
      budget: userId ? studentPreferences.budget : getStoredBudget()
    },
    onError: handleError
  }, /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(PreferencesContainer, {
    skipButton: /*#__PURE__*/React.createElement(Button, {
      emphasis: "highlighted",
      intent: "secondary",
      size: "lg",
      onClick: skipBudgetSubmit,
      width: "fill",
      type: "button"
    }, "Skip"),
    submitButton: /*#__PURE__*/React.createElement(Button, {
      emphasis: "contained",
      intent: "primary",
      size: "lg",
      width: "fill",
      type: "submit"
    }, "Next")
  }, /*#__PURE__*/React.createElement(Field, {
    as: RadioGroup,
    name: "budget",
    label: /*#__PURE__*/React.createElement(Text, {
      variant: "titleL"
    }, "What's your estimated yearly tuition budget?"),
    required: false
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    gap: 1
  }, BUDGET_OPTIONS.map(function (option) {
    return /*#__PURE__*/React.createElement(RadioGroup.Option, {
      key: option.value,
      label: option.label,
      value: option.value
    });
  }))))));
};